import { render } from "./MentionsLegalesView.vue?vue&type=template&id=8135f3e6&scoped=true"
import script from "./MentionsLegalesView.vue?vue&type=script&lang=js"
export * from "./MentionsLegalesView.vue?vue&type=script&lang=js"

import "./MentionsLegalesView.vue?vue&type=style&index=0&id=8135f3e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8135f3e6"]])

export default __exports__